var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "followup-rule" },
    [
      _c(
        "a-spin",
        {
          attrs: {
            spinning: _vm.submitLoading,
            tip: "提交中...",
            size: "large",
          },
        },
        [
          _c(
            "a-form",
            {
              attrs: { form: _vm.form },
              on: { submit: _vm.addClueRuleConfig },
            },
            [
              _c(
                "a-form-item",
                [
                  _c(
                    "div",
                    { staticClass: "header-row" },
                    [
                      _c("h3", [_vm._v("意向等级下次跟进时间规则")]),
                      _c("a-button", {
                        staticStyle: { "margin-left": "10px" },
                        attrs: {
                          type: "danger",
                          icon: "plus",
                          shape: "circle",
                          size: "small",
                        },
                        on: { click: _vm.handleAdd },
                      }),
                    ],
                    1
                  ),
                  _vm._l(_vm.clueRuleConfigList, function (rule, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "rule-item" },
                      [
                        _c("span", { staticClass: "serial-number" }, [
                          _vm._v("(" + _vm._s(index + 1) + ")"),
                        ]),
                        _c("span", { staticClass: "label" }, [
                          _vm._v("意向级别为"),
                        ]),
                        _c(
                          "a-select",
                          {
                            staticClass: "select-level",
                            attrs: {
                              mode: "multiple",
                              placeholder: "选择意向级别",
                            },
                            on: { change: _vm.validate },
                            model: {
                              value: rule.intentionLevelArr,
                              callback: function ($$v) {
                                _vm.$set(rule, "intentionLevelArr", $$v)
                              },
                              expression: "rule.intentionLevelArr",
                            },
                          },
                          _vm._l(_vm.levelOptions, function (opt) {
                            return _c(
                              "a-select-option",
                              { key: opt.codeId, attrs: { value: opt.codeId } },
                              [_vm._v(" " + _vm._s(opt.codeName) + " ")]
                            )
                          }),
                          1
                        ),
                        _c("span", { staticClass: "label" }, [
                          _vm._v("的线索时需要在，"),
                        ]),
                        _c("a-input-number", {
                          staticClass: "input-days",
                          attrs: { min: 1 },
                          on: { change: _vm.validate },
                          model: {
                            value: rule.nextFollowTime,
                            callback: function ($$v) {
                              _vm.$set(rule, "nextFollowTime", $$v)
                            },
                            expression: "rule.nextFollowTime",
                          },
                        }),
                        _c("span", { staticClass: "label" }, [
                          _vm._v("天内，完成跟进。"),
                        ]),
                        index > 0
                          ? _c("a-button", {
                              staticClass: "delete-btn",
                              staticStyle: { "margin-left": "10px" },
                              attrs: {
                                type: "danger",
                                size: "small",
                                icon: "minus",
                                shape: "circle",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(index)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  _c(
                    "div",
                    { staticStyle: { color: "red", "margin-left": "8px" } },
                    [_vm._v(" " + _vm._s(_vm.error) + " ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "submit-row" },
                    [
                      _c(
                        "a-button",
                        {
                          staticStyle: { "margin-top": "16px" },
                          attrs: { type: "primary", "html-type": "submit" },
                        },
                        [_vm._v(" 提交 ")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }